<!-- about -->
<template>
  <div class=" base-layout-container">
    <main class="main-container">
      <aside class="side-list-container">
        <ul class="side-list-wrapper">
          <li class="has-more " v-scroll-to="'#a'+index" v-for="(item,index) in list" :key="index" :class="active == index ? 'isActive' : ''" @click="clickScript (index)">
            <p class="link-container">
              <a>{{item.name}}</a>
            </p>
            <aside class="side-list-container">
              <ul class="side-list-wrapper"></ul>
            </aside>
          </li>
        </ul>
      </aside>
      <div class="article-wrapper" id="wraper">
        <article>
          <div class="syl-image-wrapper">
            <div class="f6w00t0" style="text-align: center">
               <h3 class="article-title">{{$t('safety14')}}</h3>
            </div>
          </div>
          <h2>
            <a id="a0" class="positiona"></a>
            <strong
              ><font style="font-size: 1.125em"
                ><font style="color: rgba(0, 0, 0, 1)">{{$t('safety15')}}</font></font
              ></strong
            >
          </h2>
           <p>
            <font style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)"><p>{{$t('safety16')}}</p></font>
            </font>
          </p>
          <p>
            <font style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <p>{{$t('safety17')}}</p>
                <p>{{$t('safety18')}}</p>
                <p>{{$t('safety19')}}</p>
                </font>
            </font>
          </p>
          <p><br /></p>
          <h2>
            <strong
              ><font style="font-size: 1.125em"
                ><font style="color: rgba(0, 0, 0, 1)"
                  >{{$t('safety20')}}</font
                ></font
              ></strong
            >
          </h2>
          <p>
            <font style="font-size: 1em"
              ><font style="color: rgba(0, 0, 0, 1)">
                <p>{{$t('safety21')}}</p>
                </font
              ></font
            >
          </p>
          <p><br /></p>
          <h2>
            <strong
              ><font style="font-size: 1.125em"
                ><font style="color: rgba(0, 0, 0, 1)"
                  >{{$t('safety22')}}</font
                ></font
              ></strong
            >
          </h2>
          <p>
            <font style="font-size: 1em"
              ><font style="color: rgba(0, 0, 0, 1)">
                <p>{{$t('safety23')}}</p>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a1" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety24')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety25')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety26')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety27')}}</font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a2" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety28')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety29')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety30')}}
                        <ul>
                          <li>
                            <font>
                              <font>{{$t('safety31')}}</font>
                            </font>
                          </li>
                          <li>
                            <font>
                              <font>{{$t('safety32')}}</font>
                            </font>
                          </li>
                          <li>
                            <font>
                              <font>{{$t('safety33')}}</font>
                            </font>
                          </li>
                          <li>
                            <font>
                              <font>{{$t('safety34')}}</font>
                            </font>
                          </li>
                        </ul>
                      </font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety35')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety36')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety37')}}</font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a3" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety38')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety39')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety40')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety41')}}</font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a4" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety42')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety43')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety44')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety45')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety46')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety47')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety48')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety49')}}</font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a5" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety50')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety51')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety52')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety53')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety54')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety55')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety56')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety57')}}</font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a6" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety58')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety59')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety60')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety61')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety62')}}
                        <ul>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety63')}}</font>
                            </font>
                          </li>
                        </ul>
                      </font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a7" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety64')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety65')}}
                        <ul>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety66')}}</font>
                            </font>
                          </li>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety67')}}</font>
                            </font>
                          </li>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety68')}}</font>
                            </font>
                          </li>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety69')}}</font>
                            </font>
                          </li>
                        </ul>
                      </font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p><br /></p>
          <h2>
            <strong
              ><font style="font-size: 1.125em"
                ><font style="color: rgba(0, 0, 0, 1)"
                  >{{$t('safety70')}}</font
                ></font
              ></strong
            >
          </h2>
          <p>
            <font style="font-size: 1em"
              ><font style="color: rgba(0, 0, 0, 1)">{{$t('safety71')}}</font></font
            >
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a8" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety72')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety73')}}
                        <ul>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety74')}}</font>
                            </font>
                          </li>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety75')}}</font>
                            </font>
                          </li>
                        </ul>
                      </font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a9" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety76')}}&nbsp;</font></font></strong></p>
                <p>{{$t('safety77')}}</p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety78')}}
                        <ul>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety79')}}</font>
                            </font>
                          </li>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety80')}}</font>
                            </font>
                          </li>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety81')}}</font>
                            </font>
                          </li>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety82')}}</font>
                            </font>
                          </li>
                        </ul>
                      </font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a10" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety83')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety84')}}</font>
                    </font>
                  </li>
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety85')}}</font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p>
            <font  style="font-size: 1em">
              <font style="color: rgba(0, 0, 0, 1)">
                <a id="a11" class="positiona"></a>
                <p><strong><font style="font-size: 1em"><font style="color: rgba(0,  0,  0, 1)">{{$t('safety86')}}&nbsp;</font></font></strong></p>
                <ul class="">
                  <li>
                    <font style="font-size: 1em">
                      <font style="color: rgba(0,  0,  0, 1)">{{$t('safety87')}}
                        <ul>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety88')}}</font>
                            </font>
                          </li>
                          <li>
                            <font style="font-size: 1em">
                              <font style="color: rgba(0,  0,  0, 1)">{{$t('safety89')}}</font>
                            </font>
                          </li>
                          <li>
                          <font style="font-size: 1em">
                            <font style="color: rgba(0,  0,  0, 1)">{{$t('safety90')}}</font>
                          </font>
                        </li>
                        <li>
                          <font style="font-size: 1em">
                            <font style="color: rgba(0,  0,  0, 1)">{{$t('safety91')}}</font>
                          </font>
                        </li>
                        <li>
                          <font style="font-size: 1em">
                            <font style="color: rgba(0,  0,  0, 1)">{{$t('safety92')}}</font>
                          </font>
                        </li>
                        <li>
                          <font style="font-size: 1em">
                            <font style="color: rgba(0,  0,  0, 1)">{{$t('safety93')}}</font>
                          </font>
                        </li>
                        <li>
                          <font style="font-size: 1em">
                            <font style="color: rgba(0,  0,  0, 1)">{{$t('safety94')}}</font>
                          </font>
                        </li>
                        <li>
                          <font style="font-size: 1em">
                            <font style="color: rgba(0,  0,  0, 1)">{{$t('safety95')}}</font>
                          </font>
                        </li>
                        </ul>
                      </font>
                    </font>
                  </li>
                </ul>
              </font>
            </font>
          </p>
          <p><br /></p>
        </article>
      </div>
    </main>
    <backTop></backTop>
  </div>
</template>

<script>
import backTop from './back-top.vue'
export default {
  name: 'our-community-guidelines',
  components: {
    backTop
  },
  data () {
    return {
      list: [
        {
          name: 'Introduction'
        },
        {
          name: 'Violent and Hateful Behaviour'
        },
        {
          name: 'Adult-themed Content'
        },
        {
          name: 'Bullying & Harassment'
        },
        {
          name: 'Child Safety'
        },
        {
          name: 'Suicide & Self-Harm'
        },
        {
          name: 'Illegal or Criminal Activities'
        },
        {
          name: 'Private Information'
        },
        {
          name: 'Account Authenticity'
        },
        {
          name: 'Name Policy'
        },
        {
          name: 'Deceptive behaviour and Spam'
        },
        {
          name: 'Photos, Shares, and Video Streaming Guidelines'
        }
      ],
      active: 0
    }
  },
  methods: {
    clickScript (index) {
      this.active = index
    }
  }
}
</script>
<style lang='scss' scoped>
@import "@/assets/style/vars.scss";
@media (min-width: 750px) {
  .to-top{
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
    background: center center / contain no-repeat transparent;
    transition: opacity 300ms ease 0s;
    cursor: pointer;
    z-index: 7;
}
  .isActive::before{
      content: "";
      display: block;
      position: absolute;
      left: -8px;
      bottom: 0;
      width: 2px;
      height: 100%;
      background-color: #6B10FF;
  }
.positiona{
  position:relative;
  top:-120px;
}
.f6w00t0{
  width: 100%;
  height: 300px;
  background: url('../assets/images/banner-6.png') no-repeat;
  background-size:  100% 100%;
}
.base-layout-container {
    padding: 64px 20px 77px;
    width: 1150px;
    max-width: 100%;
    box-sizing: border-box;
    margin: auto;
    background: #ffffff;
}
.article-title{
    margin-bottom: 40px;
    color: #ffffff;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
}
.side-list-container {
    position: relative;
}
aside {
    display: block;
}
.side-list-container .side-list-wrapper {
    list-style: none;
    padding: 0;
    margin: 0;
    position: fixed;
    text-align: left;
    width: 240px;
    top: 230px;
}
ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    a{
      text-decoration: none;
      text-align: left;
      color: black;
    }
}
.side-list-container .side-list-wrapper li {
    font-family: "sofiapro-medium",PingFangSC,sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 12px;
    position: relative;
    cursor: pointer;
}
.article-wrapper {
    -webkit-flex: 0 1 1152px;
    -ms-flex: 0 1 1152px;
    flex: 0 1 1152px;
    max-width: 1152px;
    padding: 50px;
    box-shadow: 0px 8px 7px 0px;
    border-radius: 8px;
    box-sizing: border-box;
    overflow:auto;
    text-align: left;
    h2{
      font-weight: 700;
      font-size: 33px;
      line-height: 1;
      margin-bottom: 24px;
    }
    h3{
      font-size: 40px;
      line-height: 300px;
      margin-bottom: 16px;
    }
    strong {
      font-weight: bold;
    }
     p {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 16px;
      color: #4f525a;
    }
}
.base-layout-container .main-container>.side-list-container {
    -webkit-flex: 0 0 240px;
    -ms-flex: 0 0 240px;
    flex: 0 0 240px;
    width: 240px;
    margin-right: 24px;
    -webkit-align-self: stretch;
    -ms-flex-item-align: stretch;
    align-self: stretch;
}
.base-layout-container .main-container {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: flex-start;
    -webkit-box-align: flex-start;
    -ms-flex-align: flex-start;
    align-items: flex-start;
}
  .community-guidelines {
    margin-top: 20px;
    .banner {
      height: 632px;
      background: url("../assets/images/banner-3.png") no-repeat center bottom,
        linear-gradient(180deg, #ffffff 0%, #d5c2ff 100%);
    }
    .banner-text {
      width: 999px;
      margin: 0 auto;
      padding-top: 30px;
      p {
        margin-bottom: 15px;
        font-size: 24px;
        line-height: 28px;
        color: #5e5e5e;
      }
      .title {
        color: #ffffff;
        font-size: 45px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 40px;
      }
    }
    .full-row {
      width: 100%;
      padding: 80px 0;
      &:nth-child(odd) {
        background-color: #fafafa;
      }
      .img-text-warp {
        width: 990px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        dt {
          width: 408px;
          height: 381px;
        }
        dd {
          text-align: left;
        }
        .row-title {
          font-size: 40px;
          line-height: 47px;
          font-weight: bold;
          color: #333;
          margin-bottom: 25px;
        }
        .row-p {
          color: #6b6b6b;
          font-size: 24px;
          line-height: 32px;
          margin-bottom: 15px;
        }
        .row-link {
          color: #1466ed;
          font-size: 24px;
        }
      }
    }
    .row-footer {
      width: 970px;
      margin: 30px auto 90px auto;
      .title {
        font-size: 40px;
        line-height: 47px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .content {
        color: #6b6b6b;
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 15px;
      }
    }
    .margin-l {
      margin-left: 40px;
    }
    .margin-r {
      margin-right: 40px;
    }
    .mobile {
      display: none;
    }
  }
}
@media (max-width: 750px) {
    .to-top{
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
    background: center center / contain no-repeat transparent;
    transition: opacity 300ms ease 0s;
    cursor: pointer;
    z-index: 7;
}
.positiona{
  position:relative;
  top:-75px;
}
.f6w00t0{
  width: 100%;
  height: 100px;
  background: url('../assets/images/banner-6.png') no-repeat;
  background-size:  100% 100%;
}
.side-list-container .side-list-wrapper .side-list-container {
    padding-left: 10px;
    margin-top: 12px;
}
.side-list-container {
    position: relative;
}
.article-wrapper {
    -webkit-flex: 0 1 1152px;
    -ms-flex: 0 1 1152px;
    flex: 0 1 1152px;
    max-width: 1152px;
    padding: 40px;
    border-radius: 8px;
    box-sizing: border-box;
    overflow:auto;
    text-align: left;
    h2{
      font-weight: 700;
      font-size: 22px;
      line-height: 1;
      margin-bottom: 24px;
    }
    h3{
      font-size: 22px;
      line-height: 100px;
      margin-bottom: 16px;
    }
    strong {
      font-weight: bold;
    }
     p {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 16px;
      color: #4f525a;
    }
}
.link-container{
  padding-right: 8px;
}
.link-container::after {
    content: "";
    position: absolute;
    right: 0px;
    box-sizing: border-box;
    width: 8px;
    height: 8px;
    border-right: 2px solid #6B10FF;
    border-bottom: 2px solid #6B10FF;
    -webkit-transform: rotate(
-45deg
);
    -ms-transform: rotate(-45deg);
    transform: rotate(
-45deg
);
    -webkit-transition: -webkit-transform 0.3s;
    -webkit-transition: transform 0.3s;
    transition: transform 0.3s;
}
  .article-title {
    font-family: "sofiapro-bold",PingFangSC,sans-serif;
    font-weight: bold;
    font-size: 35px;
    margin-bottom: 24px;
    text-align: center;
    color: #ffffff;
}
.base-layout-container {
    padding: 26px;
    width: auto;
}

.base-layout-container {
    padding: 10px 20px 0px;
    width: 1150px;
    max-width: 100%;
    box-sizing: border-box;
    margin: auto;
    background: #ffffff;
}
.side-list-container{
  text-align: left;
}
ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    a{
      text-decoration: none;
      text-align: left;
      color: black;
    }
}
  .community-guidelines {
    margin-top: 20px;
    .banner {
      height: 355px;
      background: url("../assets/images/banner-3.png") no-repeat center bottom,
        linear-gradient(
          180deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(242, 235, 255, 1) 100%
        );
      background-size: 100%;
    }
    .banner-text {
      padding: 25px;
      p {
        margin-bottom: 10px;
        font-size: 14px;
        line-height: 18px;
        color: #5e5e5e;
      }
      .title {
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
      }
    }
    .full-row {
      width: 100%;
      padding: 40px 25px;
      &:nth-child(odd) {
        background-color: #fafafa;
      }
      .img-text-warp {
        dt {
          padding: 20px 30px 0 30px;
          img {
            max-width: 100%;
          }
        }
        dd {
          text-align: left;
        }
        .row-title {
          font-size: 22px;
          line-height: 25px;
          font-weight: bold;
          color: #333;
          margin-bottom: 10px;
        }
        .row-p {
          color: #6b6b6b;
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 8px;
        }
        .row-link {
          color: #1466ed;
          font-size: 14px;
        }
      }
    }
    .margin-l {
      margin-left: 0;
    }
    .margin-r {
      margin-right: 0;
    }
    .safety-list {
      width: 100%;
      padding: 30px 0;
      background-color: #fafafa;
      .safe-title {
        font-weight: bold;
        font-size: 22px;
        color: #333;
        text-align: center;
      }
      .list-warp {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 20px 25px;
        li {
          width: 150px;
          height: 78px;
          background-color: #ffffff;
          margin-top: 25px;
        }
      }
    }
    .row-footer {
      padding: 25px 25px 50px 25px;
      .title {
        font-size: 22px;
        line-height: 25px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
      }
      .content {
        color: #6b6b6b;
        font-size: 14px;
        line-height: 16px;
      }
    }
    .pc {
      display: none;
    }
  }
}
</style>
